import { API_ENV_URLS, API_ERROR_MESSAGES } from "../constants/api";

export async function pullCrifBureauReportCallCenter(payload) {
  if (!API_ENV_URLS.crifBureauReportsCallcentre) {
    throw new Error(API_ERROR_MESSAGES.crifPullUrlNotConfigured);
  }

  const response = await fetch(API_ENV_URLS.crifBureauReportsCallcentre, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.crifPullReadFailed);
  }

  const hasData =
    result?.data &&
    (Array.isArray(result.data)
      ? result.data.length > 0
      : typeof result.data === "object" && Object.keys(result.data).length > 0);

  if (!response.ok || result?.success !== true || !hasData) {
    throw new Error(result?.message || API_ERROR_MESSAGES.crifPullFetchFailed);
  }

  return result;
}

export async function pullCrifBureauReport(payload) {
  if (!API_ENV_URLS.crifBureauPull) {
    throw new Error(API_ERROR_MESSAGES.crifPullUrlNotConfigured);
  }

  const response = await fetch(API_ENV_URLS.crifBureauPull, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.crifPullReadFailed);
  }

  const hasData =
    result?.data &&
    (Array.isArray(result.data)
      ? result.data.length > 0
      : typeof result.data === "object" && Object.keys(result.data).length > 0);

  if (!response.ok || result?.success !== true || !hasData) {
    throw new Error(result?.message || API_ERROR_MESSAGES.crifPullFetchFailed);
  }

  return result;
}

export async function fetchCrifBureauReports(phoneNumber) {
  if (!API_ENV_URLS.crifBureauReports) {
    throw new Error(API_ERROR_MESSAGES.crifReportsUrlNotConfigured);
  }

  const response = await fetch(API_ENV_URLS.crifBureauReports, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ phone: phoneNumber }),
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.crifReportsReadFailed);
  }

  if (!response.ok) {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.crifReportsFetchFailed,
    );
  }

  const reports = Array.isArray(result?.data)
    ? result.data
    : result?.data
      ? [result.data]
      : [];

  return {
    ...result,
    data: reports,
  };
}
